import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { CartPricingLineResponse } from './CartPricingLineResponse'
import { CartAppliedPromotionDto } from './CartAppliedPromotionDto'
import { CartRejectedPromotionDto } from './CartRejectedPromotionDto'
/**
* Class CartPricingResponse
*  Результат расчёта корзины (ТЗ §5.2).
*/
export class CartPricingResponse extends ActiveModel {

  /**
  * cartBase
  *   */
  @ActiveField(0)
  cartBase: number = 0


  /**
  * discountTotal
  *   */
  @ActiveField(0)
  discountTotal: number = 0


  /**
  * cashbackAccrualTotal
  *   */
  @ActiveField(0)
  cashbackAccrualTotal: number = 0


  /**
  * accrualPointsMultiplier
  *   */
  @ActiveField(0)
  accrualPointsMultiplier: number = 0


  /**
  * payableBeforePoints
  *   */
  @ActiveField(0)
  payableBeforePoints: number = 0


  /**
  * maxPointsRedeemable
  *   */
  @ActiveField(0)
  maxPointsRedeemable: number = 0


  /**
  * walletBalance
  *   */
  @ActiveField(0)
  walletBalance: number = 0


  /**
  * pointsApplied
  *   */
  @ActiveField(0)
  pointsApplied: number = 0


  /**
  * payable
  *   */
  @ActiveField(0)
  payable: number = 0


/**
  * activePromoCode
  * 
  */
  @ActiveField()
  activePromoCode?: null | string


/**
  * promoCodeError
  * 
  */
  @ActiveField()
  promoCodeError?: null | string


/**
  * @property lines
  *   */
  @ActiveField({
    factory: [CartPricingLineResponse, () => []]
  })
  lines: Array<CartPricingLineResponse> = []


/**
  * @property appliedPromotions
  *   */
  @ActiveField({
    factory: [CartAppliedPromotionDto, () => []]
  })
  appliedPromotions: Array<CartAppliedPromotionDto> = []


/**
  * @property rejectedPromotions
  *   */
  @ActiveField({
    factory: [CartRejectedPromotionDto, () => []]
  })
  rejectedPromotions: Array<CartRejectedPromotionDto> = []
}
